// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AboutContact Component Styles */
.about-contact {
  padding: 80px 0;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
}

.about-contact__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.about-contact__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-bottom: 4rem;
}

.about-contact__section {
  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(74, 144, 226, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(74, 144, 226, 0.1);
  position: relative;
  overflow: hidden;
}

.about-contact__section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #4A90E2, #87ceeb);
  transform: translateX(-100%);
  transition: transform 0.3s ease;
}

.about-contact__section:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(74, 144, 226, 0.15);
}

.about-contact__section:hover::before {
  transform: translateX(0);
}

.about-contact__section-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.about-contact__section-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
}

.about-contact__section-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #4A90E2;
  line-height: 1.3;
}

.about-contact__highlight {
  background: #4A90E2;
  color: white;
  padding: 0.8rem 1.2rem;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
  margin-bottom: 1rem;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
}

.about-contact__highlight--clickable {
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  display: block;
  width: 100%;
  text-align: center;
  border: none;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
}

.about-contact__highlight--clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(74, 144, 226, 0.4);
  filter: brightness(1.1);
}

.about-contact__highlight--clickable:active {
  transform: translateY(0);
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
}

.about-contact__text {
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
  margin-bottom: 0.8rem;
}

.about-contact__text:last-child {
  margin-bottom: 0;
}

.about-contact__text--highlight {
  color: #4A90E2;
  font-weight: 500;
}

.about-contact__list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.about-contact__list-item {
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
  margin-bottom: 0.5rem;
  padding-left: 1.2rem;
  position: relative;
}

.about-contact__list-item::before {
  content: '→';
  position: absolute;
  left: 0;
  color: #4A90E2;
  font-weight: bold;
}

/* Special styling for delivery section */
.about-contact__section--delivery {
  border: 2px solid rgba(74, 144, 226, 0.2);
}

.about-contact__section--delivery .about-contact__highlight {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.02); }
}

/* Special styling for contact section */
.about-contact__section--contact {
  grid-column: span 2;
}

.about-contact__section--contact .about-contact__section-header {
  justify-content: center;
  flex-direction: column;
  text-align: center;
  gap: 1rem;
}

.about-contact__section--contact .about-contact__content {
  text-align: center;
  max-width: 500px;
  margin: 0 auto;
}

/* Footer */
.about-contact__footer {
  text-align: center;
  padding: 3rem 2rem;
  background: linear-gradient(135deg, #4A90E2 0%, #87ceeb 100%);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(74, 144, 226, 0.2);
}

.about-contact__closing {
  font-size: 2rem;
  font-weight: 600;
  color: white !important;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.about-contact__tagline {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.75);
  font-style: italic;
  line-height: 1.5;
  margin: 0;
}

/* Animation for sections */
.about-contact__section {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeInUp 0.6s ease forwards;
}

.about-contact__section:nth-child(1) { animation-delay: 0.1s; }
.about-contact__section:nth-child(2) { animation-delay: 0.2s; }
.about-contact__section:nth-child(3) { animation-delay: 0.3s; }
.about-contact__section:nth-child(4) { animation-delay: 0.4s; }

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 968px) {
  .about-contact__section--contact {
    grid-column: span 1;
  }
}

@media (max-width: 768px) {
  .about-contact {
    padding: 60px 0;
  }
  
  .about-contact__container {
    padding: 0 1.5rem;
  }
  
  .about-contact__grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .about-contact__section {
    padding: 1.5rem;
  }
  
  .about-contact__section-header {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  
  .about-contact__section-title {
    font-size: 1.2rem;
  }
  
  .about-contact__footer {
    padding: 2rem 1.5rem;
  }
  
  .about-contact__closing {
    font-size: 1.5rem;
  }
  
  .about-contact__tagline {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .about-contact__section {
    padding: 1.2rem;
  }
  
  .about-contact__section-icon {
    width: 40px;
    height: 40px;
    font-size: 1.1rem;
  }
  
  .about-contact__section-title {
    font-size: 1.1rem;
  }
}

/* Phone Link Styles */
.about-contact__phone-link {
  color: #4A90E2;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  border-bottom: 1px solid transparent;
}

.about-contact__phone-link:hover {
  color: #357ABD;
  text-decoration: none;
  border-bottom: 1px solid #357ABD;
  transform: translateY(-1px);
}

.about-contact__phone-link:active {
  transform: translateY(0);
}

/* Contact Links Styles */
.about-contact__contact-links {
  margin-top: 1rem;
}

.about-contact__email-link,
.about-contact__website-link,
.about-contact__instagram-link {
  color: #4A90E2;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  border-bottom: 1px solid transparent;
}

.about-contact__email-link:hover,
.about-contact__website-link:hover,
.about-contact__instagram-link:hover {
  color: #357ABD;
  border-bottom: 1px solid #357ABD;
  transform: translateY(-1px);
}

.about-contact__instagram-link {
  color: #E4405F;
}

.about-contact__instagram-link:hover {
  color: #C13584;
  border-bottom: 1px solid #C13584;
}

.about-contact__address-link {
  color: #4A90E2;
  text-decoration: none;
  transition: all 0.3s ease;
  border-bottom: 1px solid transparent;
  font-weight: 500;
}

.about-contact__address-link:hover {
  color: #357ABD;
  border-bottom: 1px solid #357ABD;
  transform: translateY(-1px);
}`, "",{"version":3,"sources":["webpack://./src/components/AboutContact.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,UAAU;EACV,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,uCAAuC,qBAAqB,EAAE;AAC9D,uCAAuC,qBAAqB,EAAE;AAC9D,uCAAuC,qBAAqB,EAAE;AAC9D,uCAAuC,qBAAqB,EAAE;;AAE9D;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;;;EAGE,cAAc;EACd,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,2BAA2B;AAC7B","sourcesContent":["/* AboutContact Component Styles */\n.about-contact {\n  padding: 80px 0;\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);\n}\n\n.about-contact__container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.about-contact__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 2rem;\n  margin-bottom: 4rem;\n}\n\n.about-contact__section {\n  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: 0 8px 32px rgba(74, 144, 226, 0.1);\n  transition: all 0.3s ease;\n  border: 1px solid rgba(74, 144, 226, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n\n.about-contact__section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #4A90E2, #87ceeb);\n  transform: translateX(-100%);\n  transition: transform 0.3s ease;\n}\n\n.about-contact__section:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 40px rgba(74, 144, 226, 0.15);\n}\n\n.about-contact__section:hover::before {\n  transform: translateX(0);\n}\n\n.about-contact__section-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.about-contact__section-icon {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  flex-shrink: 0;\n  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);\n}\n\n.about-contact__section-title {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #4A90E2;\n  line-height: 1.3;\n}\n\n.about-contact__highlight {\n  background: #4A90E2;\n  color: white;\n  padding: 0.8rem 1.2rem;\n  border-radius: 8px;\n  text-align: center;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);\n}\n\n.about-contact__highlight--clickable {\n  text-decoration: none;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  display: block;\n  width: 100%;\n  text-align: center;\n  border: none;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n.about-contact__highlight--clickable:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(74, 144, 226, 0.4);\n  filter: brightness(1.1);\n}\n\n.about-contact__highlight--clickable:active {\n  transform: translateY(0);\n  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);\n}\n\n.about-contact__text {\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #555;\n  margin-bottom: 0.8rem;\n}\n\n.about-contact__text:last-child {\n  margin-bottom: 0;\n}\n\n.about-contact__text--highlight {\n  color: #4A90E2;\n  font-weight: 500;\n}\n\n.about-contact__list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.about-contact__list-item {\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #555;\n  margin-bottom: 0.5rem;\n  padding-left: 1.2rem;\n  position: relative;\n}\n\n.about-contact__list-item::before {\n  content: '→';\n  position: absolute;\n  left: 0;\n  color: #4A90E2;\n  font-weight: bold;\n}\n\n/* Special styling for delivery section */\n.about-contact__section--delivery {\n  border: 2px solid rgba(74, 144, 226, 0.2);\n}\n\n.about-contact__section--delivery .about-contact__highlight {\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.02); }\n}\n\n/* Special styling for contact section */\n.about-contact__section--contact {\n  grid-column: span 2;\n}\n\n.about-contact__section--contact .about-contact__section-header {\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  gap: 1rem;\n}\n\n.about-contact__section--contact .about-contact__content {\n  text-align: center;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n/* Footer */\n.about-contact__footer {\n  text-align: center;\n  padding: 3rem 2rem;\n  background: linear-gradient(135deg, #4A90E2 0%, #87ceeb 100%);\n  border-radius: 16px;\n  box-shadow: 0 8px 32px rgba(74, 144, 226, 0.2);\n}\n\n.about-contact__closing {\n  font-size: 2rem;\n  font-weight: 600;\n  color: white !important;\n  margin-bottom: 1rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.about-contact__tagline {\n  font-size: 1.1rem;\n  color: rgba(255, 255, 255, 0.75);\n  font-style: italic;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* Animation for sections */\n.about-contact__section {\n  opacity: 0;\n  transform: translateY(30px);\n  animation: fadeInUp 0.6s ease forwards;\n}\n\n.about-contact__section:nth-child(1) { animation-delay: 0.1s; }\n.about-contact__section:nth-child(2) { animation-delay: 0.2s; }\n.about-contact__section:nth-child(3) { animation-delay: 0.3s; }\n.about-contact__section:nth-child(4) { animation-delay: 0.4s; }\n\n@keyframes fadeInUp {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 968px) {\n  .about-contact__section--contact {\n    grid-column: span 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .about-contact {\n    padding: 60px 0;\n  }\n  \n  .about-contact__container {\n    padding: 0 1.5rem;\n  }\n  \n  .about-contact__grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n  \n  .about-contact__section {\n    padding: 1.5rem;\n  }\n  \n  .about-contact__section-header {\n    flex-direction: column;\n    text-align: center;\n    gap: 1rem;\n  }\n  \n  .about-contact__section-title {\n    font-size: 1.2rem;\n  }\n  \n  .about-contact__footer {\n    padding: 2rem 1.5rem;\n  }\n  \n  .about-contact__closing {\n    font-size: 1.5rem;\n  }\n  \n  .about-contact__tagline {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-contact__section {\n    padding: 1.2rem;\n  }\n  \n  .about-contact__section-icon {\n    width: 40px;\n    height: 40px;\n    font-size: 1.1rem;\n  }\n  \n  .about-contact__section-title {\n    font-size: 1.1rem;\n  }\n}\n\n/* Phone Link Styles */\n.about-contact__phone-link {\n  color: #4A90E2;\n  text-decoration: none;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  border-bottom: 1px solid transparent;\n}\n\n.about-contact__phone-link:hover {\n  color: #357ABD;\n  text-decoration: none;\n  border-bottom: 1px solid #357ABD;\n  transform: translateY(-1px);\n}\n\n.about-contact__phone-link:active {\n  transform: translateY(0);\n}\n\n/* Contact Links Styles */\n.about-contact__contact-links {\n  margin-top: 1rem;\n}\n\n.about-contact__email-link,\n.about-contact__website-link,\n.about-contact__instagram-link {\n  color: #4A90E2;\n  text-decoration: none;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  border-bottom: 1px solid transparent;\n}\n\n.about-contact__email-link:hover,\n.about-contact__website-link:hover,\n.about-contact__instagram-link:hover {\n  color: #357ABD;\n  border-bottom: 1px solid #357ABD;\n  transform: translateY(-1px);\n}\n\n.about-contact__instagram-link {\n  color: #E4405F;\n}\n\n.about-contact__instagram-link:hover {\n  color: #C13584;\n  border-bottom: 1px solid #C13584;\n}\n\n.about-contact__address-link {\n  color: #4A90E2;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  border-bottom: 1px solid transparent;\n  font-weight: 500;\n}\n\n.about-contact__address-link:hover {\n  color: #357ABD;\n  border-bottom: 1px solid #357ABD;\n  transform: translateY(-1px);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
